export const GAME_VERSION = '0.1.765';
